import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import {AuthService} from "./auth.service";

export const authGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (!authService.isAuthenticated()) {
        // Só redireciona: logout() aqui destruiria o cookie de refresh de quem
        // apenas está com o access token expirado.
        router.navigate(['/login']);
        return false;
    }
    return true;
};
